import './Stack-35906b7e.css';

var classes = {"Stack":"prc-Stack-Stack-WJVsK","StackItem":"prc-Stack-StackItem-CweWT"};

export { classes as default };
